import styled from '../../config/theme'

const Container = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    max-height: 80px;
    max-width: 80px;
    height: 100%;
    width: 100%;
  }
`

const FullContainer = styled.div`
  background: #000000aa;
  height: 100vh;
  width: 100vw;

  display: flex;
  align-items: center;
  justify-content: center;
`

export {
  Container,
  FullContainer,
}
